import Blog from "../../components/Blog/Blog";
import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import Footer from "../../components/Footer/Footer";

const BlogPage = () => {
  return (
    <>
      <Navbar />
      <Blog />
      <Footer />
    </>
  );
};
export default BlogPage;
